import "../scss/frontend.scss";

import menuExplore from "./menus/menu.explore.js";

import Alpine from "alpinejs";
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'

import archiveList from "./archives/archive.index.js";
Alpine.data("archiveList", archiveList);

menuExplore.init();

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.start();
